import styled from "styled-components";
import { breakpoints } from "../../../../../constants/media";

const Container = styled.div`
  position: fixed;
  background: #00000050;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  justify-content: center;

  // Pop Up Container
  .box {
    width: 600px;
    height: auto;
    max-height: 90vh;
    min-height: calc(671px - 17px - 17px);
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: row;
    align-items: flex-start;
    align-content: flex-start;
    margin: 0 auto;
    margin-top: calc(100vh - 85vh - 100px);
    background: #fff;
    box-shadow: 0px 5px 30px rgba(9, 30, 66, 0.15);
    border-radius: 6px;
    overflow: auto;
    padding: 17px;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
  }

  // Close Button Container
  .closeButtonContainer {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  // Clouse Button
  .closeButtonContainer a {
    cursor: pointer;
    font-size: 1.5em;
    color: var(--black);
    transition: 0.1s all;
  }

  .closeButtonContainer a:hover {
    color: var(--orange) !important;
  }

  // Image Title Buttons Container
  .imageTitleButtonsContainer {
    width: 90%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    align-content: center;
  }

  // Image Title Container
  .imageTitleContainer {
    width: 50%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
  }

  // Image Container
  .imageContainer {
    width: 100%;
    max-width: 70px;
    border-right: 1px solid var(--lightgray);
  }

  // Image
  .imageContainer img {
    width: calc(100% - 10px);
    object-fit: contain;
    margin-right: 10px;
  }

  // Title
  .imageTitleContainer h4 {
    margin-left: 10px;
    font-family: Raleway;
    font-style: normal;
    font-weight: 700;
    text-align: left;
    font-size: 15px;
    color: #4b8fcc;
  }

  .coberturaContainer,
  .descuentosContainer {
    width: 90%;
    min-height: 383px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-content: start;
    align-items: start;
    margin: 35px 0px 0px 0px;
  }

  .coberturaContainer h4,
  .descuentosContainer h4 {
    width: 100%;
    text-align: left;
    font-family: Raleway;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    margin: 0px 0px 20px 0px;
    display: flex;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
    color: #004b85;
  }

  .coberturaContainer h4 span,
  .descuentosContainer h4 span {
    font-size: 17px;
    margin: 3px 10px 0px 0px;
  }

  // Text
  .coberturaContainer p,
  .descuentosContainer p {
    width: 100%;
    text-align: left;
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 13.4px;
    line-height: 24px;
    margin: 0px 0px 5px 0px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
  }

  .coberturaContainer p span,
  .descuentosContainer p span {
    color: #4b8fcc;
    font-size: 15px;
    margin: 2px 10px 0px 0px;
  }

  #carencia,
  #hastaEventos,
  #eventosAnuales {
    font-size: 12px;
    color: var(--lightgray) !important;

    span {
      color: var(--lightgray) !important;
    }
  }

  #proximoPaso {
    width: 90%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    border-top: 1px solid var(--lightgray2);
    margin: 50px 0px 0px 0px;
  }

  #proximoPaso p {
    text-align: left;
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 13.4px;
    line-height: 24px;
    margin: 10px 0px 0px 0px;
    color: var(--lightgray);
  }

  // 1024px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet1024}) {
    // Pop Up Container
    .box {
      width: 500px;
    }

    // Image Title Container
    .imageTitleContainer {
      width: 100%;
    }
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    // Pop Up Container
    .box {
      width: calc(100% - 20px);
      height: 100vh;
      max-height: none;
      margin: 0px;
      border-radius: 0px;
      padding: 8px 10px 8px 10px;
    }
  }
`;

export default Container;
